import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Capacitor } from '@capacitor/core';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';

/** Web `ng serve` / local file host; UAT + PROD web + native builds still report when DSN is set. */
function isLocalWebDevHost(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  if (Capacitor.isNativePlatform()) {
    return false;
  }
  const host = window.location.hostname.toLowerCase();
  return host === 'localhost' || host === '127.0.0.1' || host === '[::1]' || host === '::1';
}

function resolveSentryEnvironment(): string {
  if (typeof window === 'undefined') {
    return environment.environmentName;
  }
  if (Capacitor.isNativePlatform()) {
    const w = window as unknown as { __env?: string };
    if (w.__env === 'prod' || w.__env === 'uat') {
      return w.__env;
    }
    return 'native';
  }
  const { hostname } = window.location;
  if (hostname.includes(environment.stagingBaseUrl)) {
    return 'uat';
  }
  if (hostname.includes(environment.productionBaseUrl)) {
    return 'prod';
  }
  return environment.environmentName;
}

const sentryEnabled = Boolean(environment.sentryDsn) && !isLocalWebDevHost();

console.log('sentryEnabled', sentryEnabled);

if (sentryEnabled) {
  const traceTargets: (string | RegExp)[] = ['localhost'];
  try {
    traceTargets.push(new URL(environment.appEnvironmentBaseUrl).origin);
  } catch {
    /* ignore invalid base URL */
  }

  Sentry.init({
    dsn: environment.sentryDsn,
    sendDefaultPii: true,
    environment: resolveSentryEnvironment(),
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.2,
    tracePropagationTargets: traceTargets,
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => {
    console.error(err);
    Sentry.captureException(err);
  });
//